import React from 'react';

import { Field, Form } from 'react-final-form';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormErrorText from 'components/shared/FormErrorText';
import Loader from 'components/shared/Loader';
import useValidationSchema from 'hooks/useValidationSchema';

import { Title } from '../shared';
import NotificationCheckboxes from '../shared/NotificationCheckboxes';
import { useForms } from '../useForms';
import { validationSchema } from './validationSchema';

export function FlightNumber(props) {
  const {
    isClientFacing,
    getAirlinesDebounced,
    handleSubmitFlightNumber,
    dateValue,
    airlineOptions,
    handleTitleChange,
    flightNumberInitialValues,
    dateFormat,
  } = useForms(props);
  const validate = useValidationSchema(validationSchema);

  return (
    <Form
      onSubmit={handleSubmitFlightNumber}
      initialValues={{
        ...flightNumberInitialValues,
      }}
      keepDirtyOnReinitialize
      validate={validate}
      render={({ handleSubmit, submitting, submitError }) => (
        <form onSubmit={handleSubmit} autoComplete="nope">
          {submitting && <Loader isFillBlock />}

          <Title
            hint="Search for your flight using Airline + Flight Number below."
            text="Searching for Flights on"
            dateValue={dateValue}
            onChange={handleTitleChange}
            dateFormat={dateFormat}
          />

          {isClientFacing && (
            <NotificationCheckboxes
              isNotifyAgentChecked={props.isNotifyAgentChecked}
              isUpdateClientSideChecked={props.isUpdateClientSideChecked}
              setIsNotifyAgentChecked={props.setIsNotifyAgentChecked}
              setIsUpdateClientSideChecked={props.setIsUpdateClientSideChecked}
            />
          )}

          <Field component={FormGroupAdapter} name="countries" type="inputGroup">
            <Field
              component={FormGroupAdapter}
              name="airlineFsCode"
              placeholder="Type Airline Name…"
              type="select"
              label="Airline"
              async
              loadOptions={(value, callback) => getAirlinesDebounced(value, callback)}
              options={airlineOptions}
              noOptionsMessage={() => 'No options found'}
              isClearable
            />

            <Field
              name="flightNumber"
              component={FormGroupAdapter}
              label="Flight Number"
              placeholder="Type Flight Number…"
            />
          </Field>

          {submitError && <FormErrorText>{submitError}</FormErrorText>}
          {/* <pre style={{ fontSize: '16px' }}>{JSON.stringify(values, 0, 2)}</pre> */}

          <FormActions isRight>
            <Button htmlType="submit" disabled={submitting}>
              Search
            </Button>
          </FormActions>
        </form>
      )}
    />
  );
}
